import { FC, memo, PropsWithChildren } from "react";
import "./panel-title-area.scss";
interface PanelTitleAreaProps extends PropsWithChildren {
  className?: string;
}
const PanelTitleAreaComponent: FC<PanelTitleAreaProps> = ({ className = "", children }) => {
  return <div className={`panel-title-area ${className}`}>{children}</div>;
};

export const PanelTitleArea = memo(PanelTitleAreaComponent);
